module.exports = __webpack_public_path__ + "assets/img/download_label.68b39a86.png";